import React from "react";

export default function ClipBoardSvgIcon(Props) {
  return (
    <svg
      width="16"
      height="17"
      fill="none"
      viewBox="0 0 16 17"
      onClick={Props.onClick}
      className="clipBoardSvgIcon"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke="#667085"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M5 2.5H9.73333C11.2268 2.5 11.9735 2.5 12.544 2.79065C13.0457 3.04631 13.4537 3.45426 13.7094 3.95603C14 4.52646 14 5.27319 14 6.76667V11.5M4.13333 14.5H9.53333C10.2801 14.5 10.6534 14.5 10.9387 14.3547C11.1895 14.2268 11.3935 14.0229 11.5213 13.772C11.6667 13.4868 11.6667 13.1134 11.6667 12.3667V6.96667C11.6667 6.21993 11.6667 5.84656 11.5213 5.56135C11.3935 5.31046 11.1895 5.10649 10.9387 4.97866C10.6534 4.83333 10.2801 4.83333 9.53333 4.83333H4.13333C3.3866 4.83333 3.01323 4.83333 2.72801 4.97866C2.47713 5.10649 2.27316 5.31046 2.14532 5.56135C2 5.84656 2 6.21993 2 6.96667V12.3667C2 13.1134 2 13.4868 2.14532 13.772C2.27316 14.0229 2.47713 14.2268 2.72801 14.3547C3.01323 14.5 3.3866 14.5 4.13333 14.5Z"
      />
    </svg>
  );
}
